import { initializeApp } from 'firebase/app'
import { getAuth, GoogleAuthProvider } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'
import { getAnalytics, logEvent } from 'firebase/analytics'

// Safe environment variable access
const getEnvVar = (name: string, fallback: string) => {
  if (typeof process !== 'undefined' && process.env) {
    return process.env[name] || fallback
  }
  return fallback
}

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyCv9hUJGhOYcd2hl5JeVsflKhlZxEML-1U',
  authDomain: 'opslaunchpad.firebaseapp.com',
  projectId: 'opslaunchpad',
  // Fixed storage bucket format - should be projectId.appspot.com
  storageBucket: 'opslaunchpad.appspot.com',
  messagingSenderId: '943712766426',
  appId: '1:943712766426:web:55a2e17ce6caa651d798e3',
  measurementId: 'G-ZYY2Z65M8Z',
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

// Initialize services
export const auth = getAuth(app)
export const googleProvider = new GoogleAuthProvider()
// Initialize Firestore with explicit settings for better debugging
export const db = getFirestore(app)
console.log('Firestore initialized with project ID:', firebaseConfig.projectId)
export const storage = getStorage(app)

// Initialize Analytics (only in browser environment)
let analytics = null
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app)
}

// Helper function to log events
export const logAnalyticsEvent = (eventName: string, eventParams = {}) => {
  if (analytics) {
    logEvent(analytics, eventName, eventParams)
  }
}

export default app
